<template>
  <div class="box">
    <el-row class="tac">
      <el-col :span="4" class="menu-box">
        <el-menu :router="true" class="el-menu-vertical-demo" :default-active="menuActive" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
          <span v-for="(item,index) in menu" :key="'menu-' + index">
              <el-submenu :disabled="item.disabled" :index="item.path" v-if="item.items">
                <template slot="title">
                  <i :class="item.icon"></i>
                  <span>{{item.title}}</span>
                </template>
                <el-menu-item v-for="(m,i) in item.items" :key="'submenu-' + i" :index="m.path">{{m.title}}</el-menu-item>
              </el-submenu>
              <el-menu-item v-if="!item.items" :index="item.path">
                <template slot="title">
                  <i :class="item.icon"></i>
                  {{item.title}}
                </template>
              </el-menu-item>
            </span>
        </el-menu>
      </el-col>
      <el-col :span="20" class="content-box">
        <h3><span class="back" v-if="$route.meta.showBack" @click="goBack"><i class="el-icon-back"></i>&emsp;返回</span>{{$route.meta.title}}</h3>
        <div class="content">
          <slot name="content"></slot>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'NavMenuComponent',
  data () {
    return {
      menu: [
        // {title: '商品管理', disabled: false, icon: 'el-icon-postcard', items: [{title: '商品列表', path: '/goods/list'}, {title: '回收站', path: '/goods/trash'}]},
        // {title: '类目管理', disabled: false, icon: 'el-icon-postcard', items: [{title: '类目列表', path: '/category/list'}]},
        // {title: '用户管理', disabled: false, icon: 'el-icon-user', items: [{title: '用户列表', path: '/user/list'}]},
        // {title: '去水印', disabled: false, icon: 'el-icon-magic-stick', items: [{title: '去水印', path: '/parse/list'}]},
        // {title: '交易管理', disabled: true, icon: 'el-icon-s-order', items: []},
        {title: '商品管理', disabled: false, icon: 'el-icon-shopping-cart-2', path: '/milk/goods/list'},
        // {title: '学校管理', disabled: false, icon: 'el-icon-school', path: '/milk/school/list'},
        {title: '订单管理', disabled: false, icon: 'el-icon-document', path: '/milk/order/list'},
        {title: '类目管理', disabled: false, icon: 'el-icon-postcard', path: '/milk/category/list'},
        {title: '会员管理', disabled: false, icon: 'el-icon-user', path: '/milk/user/list'},
        {title: '片区管理', disabled: false, icon: 'el-icon-map-location', path: '/milk/area/list'},
        {title: '单位管理', disabled: false, icon: 'el-icon-school', path: '/milk/department/list'}
      ],
      menuActive: ''
    }
  },
  mounted () {
    let that = this
    this.menu.forEach((item) => {
      if (item.path === that.$route.path) {
        that.menuActive = item.path
      }
    })
  },
  methods: {
    goBack () {
      history.back()
    }
  }
}
</script>

<style scoped lang="less">
.box {
  height: calc(100% - 70px);

  .tac {
    height: 100%;

    .menu-box {
      background: rgb(84, 92, 100);
      height: 100%;
    }

    .content-box {
      padding: 20px;
      height: calc(100% - 40px);

      h3 {
        text-align: left;
        padding-bottom: 10px;
        .back{
          padding-right: 10px;
          margin-right: 10px;
          border-right: solid 2px #ddd;
          &:hover{
            cursor: pointer;
          }
        }
      }

      .content {
        height: calc(100% - 20px);
        border: solid 1px #ddd;
        border-radius: 5px;
        overflow: scroll;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenuComponent.vue